import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import { AiFillPicture, AiFillStar, AiFillHome} from "react-icons/ai";
import { FaBed, FaUtensils, FaMapMarkerAlt, FaBars, FaTimes, FaMountain  } from "react-icons/fa";
import { GiMountains } from 'react-icons/gi';
import { LuWaves } from "react-icons/lu";
import "../styles/Navbar.css";

const Navbar = () => {
  const [navVisible, setNavVisible] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isScrolled, setIsScrolled] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [navTop, setNavTop] = useState(0);
  const navigate = useNavigate();
  const location = useLocation(); // Detect current path
  const navRef = useRef(null);

  const showHomeLink = location.pathname === "/restaurant" || location.pathname === "/gallery" || location.pathname === "/treks/kagbhusandi" || location.pathname === "/treks/satopanth";
  const showLink = location.pathname === "/restaurant" || location.pathname === "/gallery" || location.pathname === "/treks/kagbhusandi" || location.pathname === "/treks/satopanth";

  const toggleNav = () => {
    setNavVisible((prev) => !prev);
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      if (window.innerWidth >= 768) {
        setNavVisible(false);
      }
    };

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

   useEffect(() => {
    if (navRef.current) {
      setNavTop(navRef.current.offsetHeight);
    }
  }, []);

  return (
    <div>
       {/* Background overlay */}
      {windowWidth < 768 && navVisible && <div className="nav-overlay" onClick={()=>{toggleNav()}}></div>}
      <header className={`navbar ${isScrolled ? "scrolled" : ""}`} ref={navRef}>
        <img src="/Logo.jpg" alt="logo" onClick={() => scrollToSection("home")}/>
        <nav className={`nav-links ${navVisible ? "visible" : ""}`}>
           {/* Show "Home" only on restaurant or gallery routes */}
          {showHomeLink && (
            <button onClick={() => { navigate("/"); toggleNav(); }}>
              <AiFillHome className="icon" /> Home
            </button>
          )}
          {!showLink && <button onClick={() => { scrollToSection("rooms"); toggleNav();}}>
            <FaBed className="icon"/>Rooms
          </button>}
          <div className="dropdown-wrapper" onMouseLeave={() => setDropdown(false)}>
          <button className="dropdown-toggle" onClick={() => setDropdown((prev) => !prev)} onMouseEnter={() => windowWidth > 768 && setDropdown(true)}>
            <FaMountain className="icon"/> Treks
          </button>
          {dropdown && (
            <div className="ul-container" style={dropdown && windowWidth > 768 ? { top: `${navTop}` } : {}}>
              <button onClick={() => { navigate("/treks/kagbhusandi"); toggleNav(); setDropdown(false); }}>
                <GiMountains className="icon"/> Kagbhusandi Tal
              </button> 
              <button onClick={() => { navigate("/treks/satopanth"); toggleNav(); setDropdown(false); }}>
                <LuWaves className="icon"/> Satopanth Tal
              </button>
            </div>)}
          </div>

          <button onClick={() => { navigate("/restaurant"); toggleNav(); }}>
            <FaUtensils className="icon"/> Restaurant
          </button>
          
          <button onClick={() => { navigate("/gallery"); toggleNav(); }}>
            <AiFillPicture className="icon"/> Gallery
          </button>
          {!showLink && <button onClick={() => { scrollToSection("reviews"); toggleNav(); }}>
            <AiFillStar className="icon"/> Review
          </button>}
          {!showLink && <button onClick={() => { scrollToSection("footer"); toggleNav(); }}>
            <FaMapMarkerAlt className="icon"/> Location
          </button>}
        </nav>

        {windowWidth < 768 && (
          <button className="dropdown" onClick={toggleNav} aria-expanded={navVisible}>
            {navVisible ? <FaTimes className="menu-icon"/> : <FaBars className="menu-icon" />}
          </button>
        )}
      </header>
    </div>
  );
};

export default Navbar;
